<div class='demo-app'
     [class.height-reduce-20]="mobileContainer.state === 'my_schedule'"
     [class.height-reduce-100]="mobileContainer.state === 'trainer_view'">

  <div class='demo-app-main' #calendarContainer [class.hidden] = "!calendarDataLoaded">
    <full-calendar [options]='calendarOptions' #calendar></full-calendar>
  </div>
  <div *ngIf="!calendarDataLoaded" class="internal-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>

  <!-- todo: remove below -->
  <div class='demo-app-sidebar' style="display: none">
    <div class="external-event-wrapper" #externalEvents>
      <h3 class="title">Draggable Events</h3>
      <p class="subtitle">Just drap and drop events from there directly into the calendar.</p>

      <!--      <mat-card class="external-event" data-event-class="bg-success">-->
      <!--        <mat-card-content class="external-event-content">-->
      <!--          <div class="circle green"></div>-->
      <!--          <p>Make a tea</p>-->
      <!--        </mat-card-content>-->
      <!--      </mat-card>-->

      <!--      <mat-card class='external-event' data-event-class="bg-warn">-->
      <!--        <mat-card-content class="external-event-content">-->
      <!--          <div class="circle yellow"></div>-->
      <!--          <p>Open windows</p>-->
      <!--        </mat-card-content>-->
      <!--      </mat-card>-->

      <!--      <mat-card class='external-event' data-event-class="bg-primary">-->
      <!--        <mat-card-content class="external-event-content">-->
      <!--          <div class="circle violet"></div>-->
      <!--          <p>Some stuff</p>-->
      <!--        </mat-card-content>-->
      <!--      </mat-card>-->

      <mat-card *ngFor='let event of eventTemplates' class='external-event'
                [attr.eventInput-json]="eventInputJson(event)"
                [attr.eventInput-title]="event.title"
                [attr.eventInput-backgroundColor]="event.backgroundColor"
                [attr.eventInput-extendedProps]="event.extendedProps">
        <mat-card-content class="external-event-content">
          <div class="circle violet"></div>
          <p>{{event.title}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    <div class='demo-app-sidebar-section'>
      <h2>Instructions</h2>
      <ul>
        <li>Select dates and you will be prompted to create a new event</li>
        <li>Drag, drop, and resize events</li>
        <li>Click an event to delete it</li>
      </ul>
    </div>
    <div class='demo-app-sidebar-section'>
      <h2>All Events ({{currentEvents.length}})</h2>
      <ul>
        <li *ngFor='let event of currentEvents'>
          {{event.id}}<br/>
          <b>{{event.startStr}}</b>
          <i>{{event.title}}</i><br/>
          {{event.extendedProps['description']}}
        </li>
      </ul>
    </div>
  </div>
</div>
